'use strict';

var $    = require('jquery');
var _    = require('underscore');
var Core = require('../core/core.js');
var InspectorCustomSelectbox = require('./inspector__selectbox__custom.js');

/**
 * Creates an inspector with selectbox
 *
 * @class
 */

class InspectorSelectbox extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'options': [],
				'tooltip': '',
                'read_only' : false
			}
		};
	}

	constructor(options, customFlag) {
		super(options);

		this.customFlag = (typeof customFlag != "undefined" ? customFlag : true);

		this.template = `
			<div class="editor__inspector__item editor__inspector__item--single">
				<div class="editor__inspector__item__label" title="<%- tooltip %>"><%- title %></div>
				<select class="editor__inspector__item__select editor__inspector__item__select--single js-inspector__select" <% if(read_only){ %>disabled="disabled" readonly="readonly"<% } %>>
					<% _.each(options, function(option){ %>
						<option value='<%- option["value"] %>' name='<%- option["name"] %>'><%- option["name"] %></option>
					<% }); %>
				</select>
			</div>
		`;

		super.render();

		/**
		* Selectbox
		*
		* @fires InspectorSelectbox#_optionchanged
		*/
		if(this.customFlag) {
			this.custom = this._addDropdown(options.fields.options);
		} else {
			$('.js-inspector__select', this.$el).show();
		}
		$('.js-inspector__select', this.$el).on('change', this._optionchanged);

		if(options.fields['read_only']) {
            $('.editor__inspector__item__select', this.$el).addClass('editor__inspector__item__select--read__only');
        }
	}

	/**
     * @event InspectorSelectbox#Cioui:Inspector:value
     * @property {String}Cioui:Inspector:value
     * @returns {Object} obj
     * @returns {String} obj.name - the name of the new selectbox selected option
     * @returns {String} obj.value - the value of the new selectbox selected option
     */

	_optionchanged(e){
        $(e.currentTarget).blur(); // blur to get rid of the focus
		$(e.currentTarget).trigger('Cioui:Inspector:value', $(e.currentTarget).val());
		$(e.currentTarget).trigger('Cioui:Inspector:label', $(e.currentTarget).find('option:selected').attr("name"));
	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		var selectbox = $('.js-inspector__select', this.$el);

		if($(".js-inspector__select option[value='" + value + "']", this.$el).length > 0) {
			selectbox.val(value);
		}

		if(this.customFlag) {
			this.custom.setValue(selectbox.find('option:selected').text(), value);
			this.custom.chooseOption(value);
		}
	}

	_addDropdown(opts){
		var $source = $('.js-inspector__select', this.$el);
		var $selected = $source.find('option:selected');
		var selectbox = new InspectorCustomSelectbox({
			target: this.$el,
			fields: {
				'selectedText': $selected.text(),
				'selectedValue': $selected.val()
			}
		});
		for (var idx in opts) {
			var opt = selectbox.addOption($source, selectbox, opts[idx]);
			if ($selected.val() == opts[idx].value)
				opt.selectOption();
		}
		return selectbox;
	}

	clearOptions(){
		$('.js-inspector__select', this.$el).empty();
	}

	addOption(option){
 		$('.js-inspector__select', this.$el).append($("<option>").attr("value", option.value).attr("name", option.name).text(option.name));
	}

	addOptions(options){
		var self = this;
 		options.forEach(function(option) { self.addOption(option); });
	}

}
module.exports = InspectorSelectbox;
